import getTitleimg from './getImgTitle';

export default getTitleimg;
